import React, { useRef, useState } from "react";
import { Form, Modal, Spin, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "./../../../../../../features/save/saveSlice";
import { formatText, numberWithCommas } from "../../../../../../utils";

const AssignProject = ({
  isModalOpen,
  handleCancel,
  handleFetch,
  prodd,
  setPageSize,
  setPageIndex,
  pageIndex,
  handleFetchProj,
  pageSize,
}) => {
  const urlProj = "api/v2/flid/projects/get";
  const { loading, data, count, activeObjPartners } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[urlProj] || [],
    count: state.fetch.count[urlProj] || 0,
    activeObjPartners: state.obj.activeObj["partners"],
  }));

  const { saving } = useSelector((state) => state.save);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };
  const columns = [
    {
      title: "Farmer",
      dataIndex: "farmerName",
      sorter: (a, b) => a.farmerName.localeCompare(b.farmerName),
    },
    {
      title: "Description",
      render: (item) => {
        return (
          <>
            <Tooltip title={item}>
              <div className="">{truncateText(item, 35)}</div>
            </Tooltip>
          </>
        );
      },
      dataIndex: "projectDescription",
      sorter: (a, b) =>
        a.projectDescription.localeCompare(b.projectDescription),
    },

    {
      title: "County",
      dataIndex: "countyName",
      sorter: (a, b) => a.countyName.localeCompare(b.countyName),
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a, b) => a.location.localeCompare(b.location),
    },
    {
      title: "Farm Size",
      dataIndex: "landSize",
      sorter: (a, b) => a.landSize.localeCompare(b.landSize),
    },
    {
      title: "Cost",
      dataIndex: "estimatedCost",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.estimatedCost.localeCompare(b.estimatedCost),
    },

    {
      title: "Status",
      dataIndex: "projectStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          ON_SURVEY: "#E1D77C",
          INACTIVE: "#F44336",
          PUSHED_TO_INSTALLATION: "#7DACDC",
        };

        return (
          <div
            className={`${
              item === "ON_SURVEY" ? "text-black" : "text-white"
            } inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]`}
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
  ];
  const [rowId, setRowId] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  
  const handleEmployeeToReturns = async (selectedRows) => {
    await setRowId(selectedRows);
  };

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
    handleEmployeeToReturns(rows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onFinish = async () => {
    const res = await dispatch(
      save({
        verifierId: activeObjPartners?.ipId,
        projectList: selectedRowKeys?.join(","),
        url: "api/v2/flid/projects/assignToVerifier",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  return (
    <Modal
      title={`Assign ${activeObjPartners?.mipName} a project`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[89.5rem] !min-h-[30vh]"
      maskClosable={false}
    >
      <Table
        rowSelection={rowSelection}
        className="mt-[1.31rem] w-full"
        scroll={{
          x: 'auto',
        }}
        rowKey={(record) => record?.projectId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            handleFetchProj(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
      <div className="flex justify-between mt-[48px] ">
        <div className="justify-start"></div>
        <div className="justify-end flex items-center mb-[58px] gap-x-5">
          <div className="w-[150px]">
            <button
              type="button"
              key="back"
              onClick={handleCancel}
              className="cstm-btn"
            >
              Cancel
            </button>
          </div>

          <div className="w-[150px]">
            <button
              onClick={onFinish}
              disabled={saving}
              type="button"
              className="cstm-btn-2"
            >
              {saving ? <Spin /> : "Assign"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AssignProject;
